import { render, staticRenderFns } from "./MaterialMayorSection.vue?vue&type=template&id=17d4129a&scoped=true&"
import script from "./MaterialMayorSection.vue?vue&type=script&lang=js&"
export * from "./MaterialMayorSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4129a",
  null
  
)

export default component.exports